import {
  LdAccordion,
  LdAccordionPanel,
  LdAccordionSection,
  LdAccordionToggle,
  LdTypo,
} from "@emdgroup-liquid/liquid/dist/react";
import styled from "@emotion/styled";

export const StyledAccordion = styled(LdAccordion)``;
export const StyledAccordionSection = styled(LdAccordionSection)``;
export const StyledAccodionToggle = styled(LdAccordionToggle)`
  color: blue;
  .ld-accordion-toggle__label {
    background-color: grey;
  }
`;
export const StyledAccordionPanel = styled(LdAccordionPanel)``;
export const StyledText = styled(LdTypo)`
  margin-left: 5px;
  color: grey;
`;

export const StyledSpanRed = styled.span<{ potentialOfftarget?: boolean }>`
  color: red;

  ${({ potentialOfftarget }) =>
    !potentialOfftarget &&
    `
    font-family: monospace;
    letter-spacing: 2px;
  `}
`;